import Affiliations from './Affiliations';

export default Affiliations;



